import { createAction } from '@reduxjs/toolkit'
import { NFTFilterTypes, UnbindInfoTypes } from '../types'

export const setMarketFilter = createAction<NFTFilterTypes[]>('nft/setMarketFilter')
export const setMyNftFilter = createAction<NFTFilterTypes[]>('nft/setMyNftFilter')

export const setDeleteLabelId = createAction<string>('nft/setDeleteLabelId')
export const setMyNftDeleteLabelId = createAction<string>('nft/setMyNftDeleteLabelId')

export const setMarketFilterMinPrice = createAction<string>('nft/setMarketFilterMinPrice')
export const setMarketFilterMaxPrice = createAction<string>('nft/setMarketFilterMaxPrice')

export const setMyNFTFilterMinPrice = createAction<string>('nft/setMyNFTFilterMinPrice')
export const setMyNFTFilterMaxPrice = createAction<string>('nft/setMyNFTFilterMaxPrice')
export const setUnbindInfo = createAction<UnbindInfoTypes>('nft/setUnbindInfo')
export const setOpenFilter = createAction<boolean>('nft/setOpenFilter')
